import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router';
import { appRouterPaths } from 'shared/contants';
import { MenuItem } from 'shared/types';
import { GLOBAL_CONFIG } from 'config/config';
import { Page } from 'config/types';
import { classNames } from 'shared/utils';
import styles from './left-nav.module.scss';

export const AppLeftNav = () => {
  const location = useLocation();
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  
  useEffect(() => {
	const pathnameParts = location.pathname.split('/').filter(Boolean);
	const targetPage = GLOBAL_CONFIG.pages.find(
	  (page: Page) => (page.type === pathnameParts[0] && page.id === Number(pathnameParts[1]))
	);
 
	const getMenuItemFromPage = (page: Page, isChildRoute: boolean) => ({
	  id: page.id,
	  type: page.type,
	  name: page.title,
	  link: `/${page.type}/${page.id}`,
	  selected: page.type === pathnameParts[0] && page.id === Number(pathnameParts[1]),
	  isChildRoute
	});
 
	const buildRootMenuItems = (isMainPageSelected: boolean = false) => {
	  const pathnameParts = location.pathname.split('/').filter(Boolean);
	  const parentPages = GLOBAL_CONFIG.pages.filter((page: Page) => !page.parentId);
	  const parentMenuItems: MenuItem[] = parentPages.map(
		(page: Page) => ({
		  id: page.id,
		  type: page.type,
		  name: page.title,
		  link: `/${page.type}/${page.id}`,
		  selected: !isMainPageSelected ? (!!pathnameParts[1] && page.id === Number(pathnameParts[1])) : false,
		  isChildRoute: false
		})
	  );
	
	  setMenuItems([
		{ name: 'Главная', link: appRouterPaths.home, selected: isMainPageSelected, isChildRoute: false },
		...parentMenuItems
	  ]);
	};
 
	if (!targetPage) {
	  buildRootMenuItems(true);
	} else {
	  if (targetPage?.parentId) {
		const mainPage = GLOBAL_CONFIG.pages.find((page: Page) => page.id === targetPage.parentId) as Page;
		const childPages = GLOBAL_CONFIG.pages.filter((page: Page) => page.parentId === targetPage.parentId);
	 
		setMenuItems([
		  { name: 'Главная', link: appRouterPaths.home, selected: false, isChildRoute: false },
		  getMenuItemFromPage(mainPage, false),
		  ...childPages.map((page: Page) => getMenuItemFromPage(page, true))
		])
	  } else {
		buildRootMenuItems();
	  }
	}
  }, [location.pathname]);
  
  return (
	<div className={styles.leftNavContainer}>
	  <div className={styles.logoWrapper}>
		<img className={styles.logo} src="./images/ministry_of_education.png" alt=""/>
	  </div>
	  <div className={styles.leftNav}>
		{menuItems.map((item, idx) => (
		  <NavLink
			key={idx}
			to={item.link}
			className={classNames(styles.menuItem, item.selected && styles.active, item.isChildRoute && styles.childRoute)}
		  >
			{ item.name }
		  </NavLink>
		))}
	  </div>
	  <div className={styles.logoWrapper}>
		<img className={styles.logo} src="./images/ismo_logo.svg" alt=""/>
	  </div>
	</div>
  );
};
